import { useCallback } from 'react';

import {
  engagementGetMessagesAction,
  engagementMessagesEmailTemplateOpenAction,
} from 'modules/redux/states/engagement/messages/actions';
import { Paging } from 'modules/pagination';
import {
  UseHandleEmailTemplate,
  UseHandleError,
  UseHandleGet,
  UseHandlePaging,
} from './types';

export const useHandleError: UseHandleError = ({
  dispatch,
  endUserId,
  page,
  pageSize,
}) =>
  useCallback(
    () =>
      dispatch(
        engagementGetMessagesAction({
          endUserId,
          page,
          pageSize,
        }),
      ),
    [dispatch, endUserId, page, pageSize],
  );

export const useHandlePaging: UseHandlePaging = ({
  dispatch,
  endUserId,
  page,
  pageSize,
}) =>
  useCallback(
    (type: Paging) => {
      dispatch(
        engagementGetMessagesAction({
          endUserId,
          page: page ? (type === Paging.NEXT ? page + 1 : page - 1) : undefined,
          pageSize,
        }),
      );
    },
    [dispatch, endUserId, page, pageSize],
  );

export const useHandleGet: UseHandleGet = ({ dispatch, endUserId }) =>
  useCallback(
    () =>
      dispatch(
        engagementGetMessagesAction({
          endUserId,
          page: 1,
          pageSize: 10,
        }),
      ),
    [dispatch, endUserId],
  );

export const useHandleEmailTemplate: UseHandleEmailTemplate = ({
  dispatch,
  endUserId,
}) =>
  useCallback(
    (id: number | null) =>
      id && dispatch(engagementMessagesEmailTemplateOpenAction(endUserId, id)),
    [dispatch, endUserId],
  );
